import templateUrl from 'emun.order/order-view.htm'
import basicController from 'servicestack/basic.controller.properties'

class OrderViewController {
    constructor($cart) {
        const $ctrl = this;
        basicController($ctrl);
    }
};

export default {
    bindings: {
        orderId: '@',
        mode: '@',
        openedit: '<'
    },
    controller: OrderViewController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};